import FakePromise from "promise";
import { isPromise } from "../utils/promisify.js";
export default function useFunctionInterceptor(interceptor) {
    return (...args) => new FakePromise((resolve, reject) => {
        if (interceptor) {
            const result = interceptor.apply(null, args);
            if (isPromise(result)) {
                result
                    .then((value) => {
                    if (value) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                    .catch(reject);
            }
            else if (result) {
                resolve();
            }
            else {
                reject();
            }
        }
        else {
            resolve();
        }
    });
}
